import React from 'react';
import { FormattedMessage } from 'react-intl';
import MaintenanceState from '@rio-cloud/rio-uikit/lib/es/MaintenanceState';

const SystemMaintenancePage = () => (
    <div className="display-flex align-items-center justify-content-center height-100pct width-100pct margin-y-20">
        <MaintenanceState
            headline={<FormattedMessage id="intl-msg:systemMaintenance.page.headline" />}
            message={<FormattedMessage id="intl-msg:systemMaintenance.page.message" />}
        />
    </div>
);

export default SystemMaintenancePage;
